import React, {useContext} from "react";
import hark from 'hark';
import {AlertContext} from "../App/App.js";
import {isMobile} from "../App/utils.js";
import Stack from "@mui/material/Stack";
import {IconButton, Tooltip} from "@mui/material";
import {inputTools} from "./constant.js";
import {speechToTextWhisperLargeV3API} from "../API/InputTools/speechToTextAPI";
import {getFileExtensionFromMimeType, getKBFileURL, getRequestId, saveBlobFileToS3} from "../API/utils";

export let mediaRecorder = {
    state: null, start: () => {
    }, stop: () => {
    }
};

let speechEvents;
let recordingInterval;

export const onSpeechToTextClick = ({
                                        isRecording,
                                        setIsRecording,
                                        setIsTalking,
                                        setSystemAlert,
                                        setMicEnabled,
                                        setMicLoading,
                                        setInputValue,
                                        sendMessage,
                                        speechToTextToolId,
                                        KB,
                                        addressToAI,
                                        setBlockingLoading
                                    }) => {

    if (isRecording) {
        if (mediaRecorder.state === 'recording') {
            setBlockingLoading(false);
            setIsRecording(false);
            clearInterval(recordingInterval);
            mediaRecorder.stop();
            speechEvents.stop();
        }
    } else {
        setBlockingLoading({text: 'Please Wait'});
        startRecording({
            setIsRecording,
            setIsTalking,
            onSuccess: (msg) => {
                sendMessage({injectedMessage: msg, toChatOnly: !addressToAI})

            },
            setSystemAlert,
            setMicEnabled,
            setMicLoading,
            speechToTextToolId,
            KB,
            setBlockingLoading,
        })
    }
}

export const SpeechToText = ({style, onClick, micEnabled, isRecording, isTalking, micLoading, setBlockingLoading}) => {
    const {setSystemAlert} = useContext(AlertContext);

    return (
        <Stack alignItems="center" spacing={2} style={style}>

            <Tooltip title={inputTools.speechToText.shortLabel}>
                <IconButton color="primary" aria-label="upload picture" component="label" onClick={onClick}>
                    {isMobile
                        ? inputTools.speechToText.iconMobile({micEnabled, isRecording, isTalking, micLoading, setBlockingLoading})
                        : inputTools.speechToText.icon({micEnabled, isRecording, isTalking, micLoading, setBlockingLoading})
                    }
                </IconButton>
            </Tooltip>

        </Stack>
    );
}

export const startRecording = async ({
                                         setIsRecording,
                                         setIsTalking,
                                         onSuccess,
                                         setSystemAlert,
                                         setMicEnabled,
                                         setMicLoading,
                                         speechToTextToolId,
                                         KB,
                                         setBlockingLoading
                                     }) => {
    let mediaStream;
    const kbId = KB?.kbId;
    try {
        mediaStream = await navigator.mediaDevices.getUserMedia({audio: true});
    } catch (e) {
        setBlockingLoading(false);
        setSystemAlert({msg: 'Mic not found', type: 'error', duration: 10000});
        setMicEnabled(false);
        return;
    }

    setMicEnabled(true);

    recordingInterval = setInterval(() => {
        setIsRecording((prev) => prev === false ? [+new Date(), +new Date()] : [prev[0], +new Date()]);
    }, 1000)


    speechEvents = hark(mediaStream, {});

    mediaRecorder = new MediaRecorder(mediaStream);

    let audioChunks = [];

    mediaRecorder.start();

    speechEvents.on('speaking', () => setIsTalking(true));
    speechEvents.on('stopped_speaking', () => setIsTalking(false));

    mediaRecorder.addEventListener('dataavailable', (event) => {
        audioChunks.push(event.data);
    });

    mediaRecorder.addEventListener('stop', async () => {
        setIsTalking(false);
        const mimeType = audioChunks?.[0]?.type;
        const audioBlob = new Blob(audioChunks);
        setMicLoading(true);
        let transcription;

        if (speechToTextToolId === "speechToText") {
            const blobURL = URL.createObjectURL(audioBlob);

            const ext = getFileExtensionFromMimeType(mimeType);
            const filename = getRequestId() + '.' + ext


            const res = await saveBlobFileToS3(({ blobURL, filename }))

            if (res.status === 200) {
                const audioURL = getKBFileURL(filename, kbId);
                transcription = await speechToTextWhisperLargeV3API(audioURL, KB, setSystemAlert)
            } else {
                alert('Audio file upload failed')
            }
        }

        // setSystemAlert({msg: JSON.stringify(mimeType), type: 'success', duration: 10000});

        setMicLoading(false);
        setIsTalking(false)

        if (transcription) {
            onSuccess(transcription);
            // setShouldSendMessage(true);
        }
    });
};

